import { bool } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import FnrTypography from "FnrTypography";

import FnrButton from "UI/FnrButton3";
import FnrContainedIcon from "UI/FnrContainedIcon";

const SendButton = ({ isLoading }) => {
  const { sendButtonRef, message } = useMemberToobarContext();
  const disabled = useMemo(() => !message, [message]);

  return (
    <ZeroHeight>
      <FnrButton
        ref={sendButtonRef}
        disabled={disabled}
        loading={isLoading}
        color="#2867ac"
        data-cy="MemberToolbar_SubmitButton"
      >
        <SendButtonInnerContainer>
          <FnrContainedIcon
            color="textLight"
            noPadding
            icon="fa-paper-plane fal"
          />
          <FnrTypography noWrap color="textLight">
            Send It
          </FnrTypography>
        </SendButtonInnerContainer>
      </FnrButton>
    </ZeroHeight>
  );
};

SendButton.propTypes = { isLoading: bool };

const ZeroHeight = styled.div`
  position: absolute;
  bottom: 72px;
  right: 4px;
  height: 0px;
`;

const SendButtonInnerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export default SendButton;
